import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import WinnerDropBadge from "../drops/winner/WinnerDropBadge";
interface WinnerBadgeProps {
  readonly drop: ApiDrop;
  readonly showBadge?: boolean;
}
export const WinnerBadge: React.FC<WinnerBadgeProps> = t0 => {
  const $ = _c(3);
  const {
    drop,
    showBadge: t1
  } = t0;
  const showBadge = t1 === undefined ? true : t1;
  const {
    winningRank
  } = useDropInteractionRules(drop);
  const winningTime = drop.winning_context?.decision_time || null;
  if (!winningRank || !showBadge) {
    return null;
  }
  let t2;
  if ($[0] !== winningRank || $[1] !== winningTime) {
    t2 = <div className="tw-flex"><WinnerDropBadge rank={winningRank} decisionTime={winningTime} /></div>;
    $[0] = winningRank;
    $[1] = winningTime;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};